<template lang="pug">
Card.selections-card
    template(#header)
        .title {{ $t('selections.houseType.title') }}
    template(#content)
        .dropdown-wrapper
            Dropdown(
                v-model="houseTypeSelected"
                :options="houseTypes"
                :optionLabel="splitLabel"
                :placeholder="$t('selections.houseType.placeholder')"
            )

</template>
<script lang="ts">
import { useSelections } from "@/store/selections";
import { HouseType } from "@/types";
import { defineComponent } from "vue";
import { storeToRefs } from "pinia";
import Card from "primevue/card";
import Dropdown from "primevue/dropdown";
import { PropType } from "vue";

export default defineComponent({
  name: "HouseType",
  components: {
    Card,
    Dropdown,
  },
  props: {
    houseTypes: Array as PropType<HouseType[]>,
  },
  setup() {
    const { houseTypeSelected } = storeToRefs(useSelections());
    const splitLabel = (value: HouseType) =>
      value.value.replace(/([A-Z])/g, " $1").trim();

    return {
      houseTypeSelected,
      splitLabel,
    };
  },
});
</script>
<style scoped lang="scss">
.dropdown-wrapper {
  .p-dropdown {
    width: 35%;
    min-width: 350px;
  }
}

@media screen and (max-width: 720px) {
  .dropdown-wrapper {
    .p-dropdown {
      width: 100%;
    }
  }
}
</style>
